import { UntypedFormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {Component, ElementRef, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {GerenciarOcorrenciasService} from 'src/app/services/gerenciar-ocorrencias.service';
import {take, takeUntil} from 'rxjs/operators';
import {BaseFormService} from 'src/app/services/base-form.service';
import {Router} from '@angular/router';
import {HomeService} from '@services/home.service';
import {Subject} from 'rxjs';
import { LoadingGenericoComponent } from '../../components/loading-generico/loading-generico.component';
import { HeaderComponent } from '../../components/header/header.component';
import { BotaoChatComponent } from '../../components/botao-chat/botao-chat.component';
import { AlertErroPadraoComponent } from '../../components/alert-erro-padrao/alert-erro-padrao.component';
import { AlertSucessoPadraoComponent } from '../../components/alert-sucesso-padrao/alert-sucesso-padrao.component';
import { AlertDescartarAlteracoesComponent } from '../../components/alert-descartar-alteracoes/alert-descartar-alteracoes.component';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { SelectOneComponent } from '../../components/select-one/select-one.component';
import { NgClass, DecimalPipe } from '@angular/common';
import { MatProgressBar } from '@angular/material/progress-bar';
import { FooterComponent } from '../../components/footer/footer.component';
import { SanitizerHtmlPipe } from '../../pipes/sanitizer-html.pipe';
import { AppDatePipe } from '../../pipes/app-date.pipe';

@Component({
    selector: 'app-abertura-ocorrencia',
    templateUrl: './abertura-ocorrencia.component.html',
    styleUrls: ['./abertura-ocorrencia.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [LoadingGenericoComponent, HeaderComponent, BotaoChatComponent, AlertErroPadraoComponent, AlertSucessoPadraoComponent, AlertDescartarAlteracoesComponent, BreadcrumbComponent, FormsModule, ReactiveFormsModule, SelectOneComponent, NgClass, MatProgressBar, FooterComponent, DecimalPipe, SanitizerHtmlPipe, AppDatePipe]
})
export class AberturaOcorrenciaComponent extends BaseFormService implements OnInit, OnDestroy {
  @ViewChild('inputFile', {static: true})
  public inputFile: ElementRef;
    file = new FormData();
    form = this.formBuilder.group({
    idTipoOcorrencia: [null, [Validators.required]],
    usuario: [null, []],
    produto: [null, []],
    pedido: [null, []],
    contato: [null, [Validators.required]],
    file: ['', []],
    detalhes: ['', Validators.compose([Validators.minLength(30), Validators.maxLength(10000)])],
    numeroOcorrencia: ['', []],
  });

  nomeArquivo = '';
  idTipoOcorrencia = 0;
  empresa: any = localStorage.idEmpresaLogada;
  loadingGenerico = false;
  tipoOcorrencia: any;
  resource: any;
  usuarioLogado = 1;
  usuarios: any;
  produtos: any;
  ocorrencia: any;
  obterProdutos: any;
  idUsuario: any;
  produtoUsuario: any;
  contatos: any;
  tituloInstrucoes = 'Selecione um Tipo de Ocorrência para Obter Instruções !';
  flagMostrarComboProduto: boolean;
  flagMostrarComboUsuario: boolean;
  alertSucesso = false;
  erro = false;
  alertErroMensagem: any = '';
  comparador: any;
  extensaoArquivo: any;
  listaExtensoes: any;
  tiposOcorrencias: any;
  destroyed$ = new Subject<void>();
  processandoDados = false;
  dataHoje: Date = new Date();
  instrucoesOcorrencia: any = '';
  descricaoErro: any;
  alertaDescarte = false;
  idOcorrencia: number;
  tiposOcorrenciasSelect: { id: any; label: string }[] = [];
  usuariosSelect:        { id: any; label: string }[] = [];
  produtosSelect:        { id: any; label: string }[] = [];
  pedidosSelect:         { id: any; label: string }[] = [];
  contatosSelect:        { id: any; label: string }[] = [];


  constructor(
    private readonly Toastr: ToastrService,
    private readonly gerenciarOcorrenciasService: GerenciarOcorrenciasService,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly router: Router,
    private readonly homeService: HomeService) {
    super();
  }

  ngOnInit(): void {
    this.getTipoOcorrencia();
    this.getContatos();
    this.getListaExtensoes();
  }


  capturarArquivo(event: any) {
    if (event.target.files?.[0]) {
      const arquivo = event.target.files[0];

      this.file.set('file', arquivo);

      this.nomeArquivo = arquivo.name;
      this.comparador = arquivo.name.split('.');
      this.extensaoArquivo = '.' + this.comparador[this.comparador.length - 1];
      if (this.listaExtensoes.includes(this.extensaoArquivo.toLowerCase())) {
        this.Toastr.success('<i class="fa fa-check-circle"></i><h2>Importação de arquivo realizada.</h2>', 'Sucesso!', {
          timeOut: 2000,
          enableHtml: true
        });
      } else {
        this.Toastr.error('<i class="fa fa-times-circle"></i><h2>Arquivo possui formato inválido!</h2>', 'Erro!', {
          timeOut: 2000,
          enableHtml: true
        });
        this.nomeArquivo = 'Selecione arquivo';
        this.erro = true;
        this.alertErroMensagem = 'Extensão do arquivo é inválida';
        this.limpaArquivoSelecionado();
      }

    } else {
      this.Toastr.error('<i class="fa fa-times-circle"></i><h2>Carregue um arquivo!</h2>', 'Erro!', {
        timeOut: 2000,
        enableHtml: true
      });    }
  }

  getTipoOcorrencia() {
    this.gerenciarOcorrenciasService
      .getTipoOcorrencia()
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (success: any) => {
          if (success) {
            this.tiposOcorrencias = success?.response;

            this.tiposOcorrenciasSelect = (this.tiposOcorrencias ?? []).map((t: any) => ({
            id: t,
            label: t.descricaoTipoOcorrencia
          }));
          }
        },
        error: (error: any) => console.log(error),
      });

  }

  getApiData() {
    this.gerenciarOcorrenciasService.getAllUsuarios(this.empresa, this.idTipoOcorrencia)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (success: any) => {
          this.resource = success.response;
          this.usuarios = success.response.empresaUsuario;
          this.produtos = success.response.pedidosCombo;
          this.ocorrencia = success.response.ocorrenciasProdutoCombo;
          this.instrucoesOcorrencia = success.response.dsInstrucaoOcorrenciaNovoPortal;

          this.usuariosSelect = (this.usuarios ?? []).map((u: any) => ({
          id: u.idUsuario,
          label: u.nomeUsuario
          }));

          this.produtosSelect = (this.produtos ?? []).map((p: any) => ({
          id: p,
          label: (p.descricao ?? '').toLowerCase()
          }));

          this.pedidosSelect = (this.produtos ?? []).map((p: any) => ({
          id: p.idPedido,
          label: (p.dsPedidoDataEmissao ?? '').toLowerCase()
          }));

          if (this.usuarios?.length) {
            this.form.get('usuario')?.setValidators([Validators.required]);
            this.form.get('usuario')?.updateValueAndValidity();
          } else {
            this.form.controls.usuario.clearValidators();
            this.form.get('usuario')?.updateValueAndValidity();
          }

          if (success.response.dsInstrucaoOcorrencia === '') {
            this.tituloInstrucoes = 'Sem Instruções da ocorrência';
          } else {
            this.tituloInstrucoes = 'Instruções da ocorrência';
          }
          if (success.response.flagMostrarComboProduto === 'S') {
            this.flagMostrarComboProduto = true;
          } else {
            this.flagMostrarComboProduto = false;
          }
          if (success.response.flagMostrarComboUsuario === 'S') {
            this.flagMostrarComboUsuario = true;
          } else {
            this.flagMostrarComboUsuario = false;
          }
        },
        error: (error) => {
            this.Toastr.error('<i class="fa fa-check-circle"></i><h2>Erro ao fazer requisição!</h2>', 'Erro!', {
            enableHtml: true
          });
        }
      })
  }

  getIdUsuario() {
    this.idUsuario = this.form.value.usuario;
    this.getProdutos();
  }

  chanceProduto() {
    this.produtoUsuario = this.form.value.produto;
  }

  getProdutos() {
    const paramsArray = this.getParamsProdutos();
    const paramsUrl = this.getParamsUrl(paramsArray);

    this.gerenciarOcorrenciasService.getAllProdutos(paramsUrl)
    .pipe(take(1))
    .subscribe({
      next: (success: any) => {
        this.obterProdutos = success.response;
      },
      error: (error) => {
        this.Toastr.error('<i class="fa fa-check-circle"></i><h2>Erro ao obter produto!</h2>', 'Erro!', {
          enableHtml: true
        });
      }
    })
  }

  getParamsProdutos() {
    const arr = [];
    arr.push({name: 'idUsuario', comparator: '=', value: this.idUsuario});
    return arr;
  }

  getContatos() {
    this.gerenciarOcorrenciasService.getContatos(this.empresa)
    .pipe(take(1))
    .subscribe({
      next: (success: any) => {
        this.contatos = success.response;

        this.contatosSelect = (this.contatos ?? []).map((c: any) => ({
          id: c.idContato,
          label: (c.nomeContato ?? '').toLowerCase()
        }));
      },
      error: (error) => {
        this.Toastr.error('Erro ao obter contatos', '', {
          timeOut: 2000,
        });
      }
    })
  }

  postDados() {
    if (this.form.invalid || this.form.value.detalhes.length < 30){
      this.form.markAllAsTouched();
      return;
    }
    this.loadingGenerico = true;
    const paramsArray = this.getParamsPost();
    const paramsUrl = this.getParamsUrl(paramsArray);
    this.gerenciarOcorrenciasService.postOcorrencia(paramsUrl, this.file)
      .pipe(take(1))
      .subscribe({
        next: (success: any) => {
          if (success.status === 'OK'){
            this.erro = false;
            this.alertSucesso = true;
            this.form.reset();
            this.idOcorrencia = success.response;
          }else {
            this.erro = true;
            this.alertErroMensagem = success.mensagem;
          }
          this.loadingGenerico = false;
        },
        error: (error) => {
          this.loadingGenerico = false;
          this.alertSucesso = false;
          this.alertErroMensagem = error.error.mensagem;
          this.erro = true;
          if (error.error.message === 'Maximum upload size exceeded; nested exception is java.lang.IllegalStateException: org.apache.tomcat.util.http.fileupload.impl.SizeLimitExceededException: the request was rejected because its size (10997144) exceeds the configured maximum (10485760)') {
            this.alertErroMensagem = 'Tamanho do arquivo superior a 10MB !';
          }
        }
      });
  }

  getParamsPost() {
    const arr = [];
    arr.push(
      {name: 'dsDetalhesOcorrencia', comparator: '=', value: this.form.value.detalhes},
      {name: 'idContato', comparator: '=', value: this.form.value.contato},
      {name: 'idEmpresa', comparator: '=', value: this.empresa},
      {name: 'idPedido', comparator: '=', value: this.form.value.pedido}
    );

    if (this.form.value.produto !== '') {

      arr.push({name: 'idProduto', comparator: '=', value: this.form.value.produto});
    }

    if (this.form.value.numeroOcorrencia !== '') {

      arr.push({name: 'idProdutoOcorrencia', comparator: '=', value: this.form.value.numeroOcorrencia});
    }

    arr.push({name: 'idTipoOcorrencia', comparator: '=', value: this.idTipoOcorrencia});

    if (this.form.value.usuario !== '') {

      arr.push({name: 'idUsuarioEmpresa', comparator: '=', value: this.form.value.usuario});
    }

    arr.push({name: 'idUsuarioLogado', comparator: '=', value: this.usuarioLogado});

    return arr;

  }

  fecharAlertSucesso() {
    this.alertSucesso = false;
    this.router.navigateByUrl('/gerenciar-ocorrencias');
  }

  fecharAlertErro() {
    this.erro = false;
  }

  private getListaExtensoes() {
    this.homeService.getExtensoes('gerenciar-ocorrencias')
    .pipe(take(1))
    .subscribe({
      next: (success: any) => {
        this.listaExtensoes = success.extensions;
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

  onChangeTipoOcorrencia($event: any) {
    this.idTipoOcorrencia = $event.idTipoOcorrencia;
    this.getApiData();
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  onChangeUsuario(idUsuario: any) {
    this.form.value.usuario = idUsuario;
  }

  onChangeProduto($event: any) {
  }

  onChangeContato(idContato: any) {
    this.form.value.contato = idContato;
  }

  limpaArquivoSelecionado() {
    this.nomeArquivo = '';
    this.inputFile.nativeElement.value = '';
    this.file.set('file', '');
  }

  onChangePedido(idPedido: any) {
    this.form.value.pedido = idPedido;
  }

  get formControl() {
    return this.form.controls;
  }

  checaPreenchimento() {
    if (this.form.controls.detalhes.touched && this.form.value.detalhes.length === 0) {
      this.form.controls.detalhes.setErrors({invalid: true});
    }
  }

  validaQuantidadeDescricao() {
    return this.form.controls.detalhes.touched && (this.form.value.detalhes.length <= 30 || this.form.value.detalhes.length === 10000);
  }

  textoContador() {
    if (this.form.controls.detalhes.touched) {
      if (this.form.value.detalhes.length <= 30 && this.form.controls.detalhes.invalid) {
        return 'quantidade mínima de caracteres';
      } else if (this.form.value.detalhes.length === 10000) {
        return 'quantidade máxima de caracteres';
      }
    } else {
      return '';
    }
  }

  sucessoFechou() {
    this.router.navigate(['detalhes-ocorrencia/' + this.idOcorrencia]);
  }

  caracteresDigitados() {
    return this.form.value.detalhes === null ? 0 : this.form.value.detalhes.length;
  }

  limparDados() {
    if (this.form.value.idTipoOcorrencia === '' &&
      this.form.value.contato === '' &&
      this.form.value.file === '' &&
      (this.form.value.detalhes === null || this.form.value.detalhes === '' )){
      this.router.navigate(['gerenciar-ocorrencias']);
    }else {
      this.alertaDescarte = true;
    }
  }

  cancelarEnvio() {
    this.router.navigate(['gerenciar-ocorrencias']);
  }

  alertaDescarteFechou() {
    this.alertaDescarte = false;
  }
}
